module.exports = __webpack_public_path__ + "static/media/P3_S11_1.08f22ad3.png";